import { useEffect, useState } from "react";
import { AccountEditor } from "../../editor/AccountEditor";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable } from "../../theme/Component/BasicTable";
import { CardTaps } from "../../theme/Component/CardTaps";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { EnjoyedVacation } from "./EnjoyedVacation";
import { useEnjoyedVacation } from "./useEnjoyedVacation";
import { AnticipatedVacation } from "./AnticipatedVacation ";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _EnjoyedVacation, _single } from "../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
interface Props {
    rol: number;
}

export const EnjoyedVacationERP = ({ rol }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_EnjoyedVacation);
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [user, setUser] = useState<number>(_single.getAccountID());
    const modal = useModal("agregar", MODAL_LG)
    const modalDocuent = useModal("agregar", MODAL_md)

    const listaBotones = () => {
        const botones = [
            { titulo: "Consultar vacaciones disfrutadas", icono: "ri-calendar-check-line", visible: true, evento: () => { modal.setModal({ ...modal.modal, "view": true, "name": "Vacaciones disfrutadas" }) } },
            { titulo: "Asignar Periodo de Vacaciones a Documento", icono: "ri-add-line", visible: true, evento: () => { assing() } },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const [indexTap, setIndexTap] = useState(0);

    const getLista = () => {
        instance.getFortnightVacationsByEmployee(year, user).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { console.log(err) })

    }

    const assing = () => {
        instance.setVacationPeriodToDocument(bean.IDDocument, bean.DocumentDate, bean.VacYear, bean.VacPeriod).then(
            (resp) => {
                toast.success("Accion Realizada")
            }
        ).catch(
            err => { toast.error("No se pudo realizar la acción") }
        )
    }

    useEffect(() => {
        if (indexTap == 0) {
            getLista();
        }
    }, [indexTap, user, year])

    const taps = [
        { id: 0, name: 'Vacaciones Pagadas' },
        { id: 1, name: 'Vacaciones Anticipadas' }
    ]

    const head = [
        { title: "ID", property: "IDDocument", visible: false },
        { title: "Consecutivo", property: "Consecutive", visible: (rol == 1) },
        { title: "Año", property: "Year", visible: (rol == 1) },
        { title: "Mes", property: "Month", visible: (rol == 1) },
        { title: "Tipo de Documento", property: "Mnemonic", visible: (rol == 1) },
        { title: "Tipo de Novedad", property: "NoveltyTypeName" },
        { title: "Nombre", property: "Name" },
        { title: "Número de días", property: "Units" },
        { title: "Año de Vacaciones", property: "VacYear" },
        { title: "Periodo de Vacaciones", property: "VacPeriod" },
        { title: "Fecha Inicio", property: "NoveltyInitDate", },
        { title: "Fecha finalización", property: "NoveltyUptoDate", },
    ];

    return (
        <BasicPage titulo="Historial de Disfrute de Vacaciones">
            <div className="row">
                <div className="col-md-4 ">
                    <YearSelector value={year} onChange={(e) => setYear(e)} />
                </div>
                {rol == 1 &&
                    <>
                        <div className="col-md-6">
                            <AccountEditor idAccount={user} label="Funcionario" onChange={({ IDAccount }: any) => { setUser(IDAccount) }} disabled={rol != 1} />
                        </div>
                        <div className="col-md-2 mt-4">
                            <BasicButton icon="ri-user-search-line" eventClick={getLista}>Buscar</BasicButton>
                        </div>
                    </>
                }
            </div>
            <div className="mt-3">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    {indexTap === 0 &&
                        <div className="row">
                            <div className="col-md-12 mt-4">
                                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} />
                            </div>
                        </div>
                    }
                    {indexTap === 1 &&
                        <AnticipatedVacation _lista={lista} _rol={rol} _user={user} _vacation={bean} />
                    }
                </CardTaps>
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} >
                <EnjoyedVacation _rol={rol} _user={user} _vacation={bean} />
            </Modal>
        </BasicPage>
    )
}